import React from 'react';

import './Home.css';

const Home = () => {
    return (
        <div className="home-content">
            <div className="content-benefits">
                <div className="content-benefit">
                    <img className="benefits-icon" src="images/simple.png" alt="Simple"></img>
                    <div className="benefits-text">
                        <div className="benefits-text-term">Simple Yet Full Featured</div>
                        <ul className="benefits-text-defintion">
                            <li>A simple countdown timer can be set and started with just 3 taps</li>
                            <li>The timer will fire even if the TimerZ app is running in the background </li>
                            <li>Multiple timers can be set and can run simultaneously </li>
                            <li>Each timer can be named and set to expire after a time interval, or at a specific point in time like an alarm </li>
                            <li>Timer activity history is saved and can be emailed for task time tracking </li>
                        </ul>
                    </div>
                </div>
                <div className="content-benefit">
                    <img className="benefits-icon" src="images/settings.png" alt="Simple"></img>
                    <div className="benefits-text">
                        <div className="benefits-text-term">Useful Settings</div>
                        <ul className="benefits-text-defintion">
                            <li>When a timer expires, there is a choice of alarm sounds, no sound at all, or vibrate</li>
                            <li>The alarm can continue to sound until acknowledged </li>
                            <li>While a timer is running, it can show remaining time or elapsed time since start, either in full hour/min/sec or just seconds </li>
                            <li>Upon expiration, a timer can start another timer, including itself in a loop </li>
                        </ul>
                    </div>
                </div>
                <div className="content-benefit">
                    <img className="benefits-icon" src="images/help.png" alt="Simple"></img>
                    <div className="benefits-text">
                        <div className="benefits-text-term">Excellent Support</div>
                        <ul className="benefits-text-defintion">
                            <li>A full set of helpful topics are just a single tap away in the Help tab of the app</li>
                            <li>You may also <a href="#/Contct">contact</a> us directly from the app with questions or suggestions</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="content-app">
                <img className="screenshot" src="images/screenshot.png" alt="TimerZ Screenshot"></img>
                <div className="break"></div>
                <div className="app-store-link">
                    <a href="http://itunes.apple.com/us/app/timer-z/id420191007?mt=8ls=1" rel="noopener noreferrer" target="_blank">
                        <img className="app-store-link-img" src="images/download.png" alt="download"/></a>
                </div>
            </div>
        </div>
    );
};

export default Home;